import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c777c65"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "bg-gray-700" }
const _hoisted_4 = { class: "d-flex align-items-center fw-bolder p-3" }
const _hoisted_5 = { class: "badge badge-light-success ms-5 fs-md-2 ms-auto" }
const _hoisted_6 = { class: "badge badge-light-warning ms-5 fs-md-2" }
const _hoisted_7 = { class: "badge badge-light-danger ms-5 fs-md-2" }
const _hoisted_8 = { class: "card mb-4 mb-md-0" }
const _hoisted_9 = { class: "card-header border-0 pt-6" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "svg-icon svg-icon-1 me-2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Search Panel ")
const _hoisted_13 = { class: "card-toolbar" }
const _hoisted_14 = {
  class: "d-flex justify-content-end",
  "data-kt-site-table-toolbar": "base"
}
const _hoisted_15 = { class: "svg-icon svg-icon-2" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Add MaterialStock ")
const _hoisted_17 = { class: "card-header border-0 pt-6 d-none" }
const _hoisted_18 = { class: "card-toolbar w-100" }
const _hoisted_19 = {
  class: "d-flex w-100 justify-content-between align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_20 = { class: "me-auto" }
const _hoisted_21 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "ms-3"
}, " All ", -1))
const _hoisted_23 = { class: "fw-bolder mx-5" }
const _hoisted_24 = { class: "me-2" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Selected ")
const _hoisted_26 = { class: "card-header border-0 pt-6" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = { class: "row w-100" }
const _hoisted_29 = { class: "col-md-12 d-flex align-items-center position-relative my-1" }
const _hoisted_30 = { class: "card-toolbar" }
const _hoisted_31 = {
  class: "d-flex justify-content-end align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_32 = {
  key: 0,
  class: "card-body pt-0 d-none d-md-block"
}
const _hoisted_33 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_34 = ["value"]
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "d-flex pt-1 justify-content-end" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil p-0" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash p-0" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "d-md-none d-block" }
const _hoisted_44 = {
  key: 0,
  class: "card"
}
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "No Data Found", -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" to add new materialStock ")
const _hoisted_48 = { class: "card-header ribbon" }
const _hoisted_49 = { class: "card-title" }
const _hoisted_50 = { class: "ribbon-label bg-info" }
const _hoisted_51 = { class: "card-body px-0 pb-0 d-flex align-items-center mb-2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px me-3" }, null, -1))
const _hoisted_53 = { class: "flex-grow-1" }
const _hoisted_54 = { class: "d-flex" }
const _hoisted_55 = { class: "" }
const _hoisted_56 = { class: "text-muted fw-bold d-block h2 mb-3" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Quantity : ")
const _hoisted_58 = { style: { color: '#2c2c2c' } }
const _hoisted_59 = { class: "text-muted fw-bold d-block h2" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Remark: ")
const _hoisted_61 = { style: { marginTop: '8px' } }
const _hoisted_62 = { style: { color: '#2c2c2c' } }
const _hoisted_63 = { class: "card-footer d-flex justify-content-center pt-5 w-100" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_69 = [
  _hoisted_68
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBack && _ctx.onClickBack(...args)))
      }, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(`badge ${
            _ctx.materialStockCount.in - _ctx.materialStockCount.out > 0
              ? 'badge-success'
              : 'badge-danger'
          } ms-5 fs-md-2`)
        }, " Balance : " + _toDisplayString(_ctx.materialStockCount.in - _ctx.materialStockCount.out || 0), 3),
        _createElementVNode("div", _hoisted_5, " In : " + _toDisplayString(_ctx.materialStockCount.in || 0), 1),
        _createElementVNode("div", _hoisted_6, " Out : " + _toDisplayString(_ctx.materialStockCount.out || 0), 1),
        _createElementVNode("div", _hoisted_7, " Waste : " + _toDisplayString(_ctx.materialStockCount.waste || 0), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "d-flex align-items-center position-relative my-1 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchPanel = !_ctx.showSearchPanel))
          }, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
            ]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMaterialStock({})))
            }, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/navigation/Plus.svg" })
              ]),
              _hoisted_16
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAllMaterialStock) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.selectAllMaterialStock]
                ]),
                _hoisted_22
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.selectAllMaterialStock ? _ctx.total : _ctx.checkedMaterialStock.length), 1),
              _hoisted_25
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportFewSites()))
            }, " Export CSV Selected ")
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchData.name) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Search By Name"
              }, null, 512), [
                [_vModelText, _ctx.searchData.name]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchItems()))
            }, " Search ")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showSearchPanel]
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": false,
              total: _ctx.total,
              rowsPerPage: 10,
              onPageChange: _ctx.onPageChange,
              currentPage: _ctx.currentPage
            }, {
              "cell-checkbox": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.selectAllMaterialStock)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        checked: "",
                        disabled: ""
                      }, null, 8, _hoisted_34))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkedMaterialStock) = $event))
                      }, null, 8, _hoisted_35)), [
                        [_vModelCheckbox, _ctx.checkedMaterialStock]
                      ])
                ])
              ]),
              "cell-qty": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.qty), 1)
              ]),
              "cell-remark": _withCtx(({ row: site }) => [
                _createElementVNode("p", null, _toDisplayString(site.remark), 1)
              ]),
              "cell-stock_type": _withCtx(({ row: site }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(`badge badge-${
                site.stock_type == 'In'
                  ? 'success'
                  : site.stock_type == 'Out'
                  ? 'warning'
                  : 'danger'
              }`)
                }, _toDisplayString(site.stock_type), 3)
              ]),
              "cell-material_data": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.material_data.code), 1)
              ]),
              "cell-created_by": _withCtx(({ row: site }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.userList[site.created_by]?.name), 1)
              ]),
              "cell-actions": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-sm mx-2",
                    onClick: ($event: any) => (_ctx.addMaterialStock(site))
                  }, _hoisted_39, 8, _hoisted_37),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger btn-sm mx-2",
                    onClick: ($event: any) => (_ctx.deleteMaterialStockItem(site))
                  }, _hoisted_42, 8, _hoisted_40)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "total", "onPageChange", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", null, [
        (_ctx.tableData.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addMaterialStock({}))),
                    class: "cursor-pointer text-primary"
                  }, "Click here"),
                  _hoisted_47
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card card-flush mb-4 shadow",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("h3", _hoisted_49, _toDisplayString(item.stock_type), 1),
              _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.userList[item.created_by]?.username), 1)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("strong", _hoisted_58, _toDisplayString(item.qty), 1)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("strong", _hoisted_62, _toDisplayString(item.remark), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary mx-2 w-100",
                style: { marginRight: '12px' },
                onClick: ($event: any) => (_ctx.addMaterialStock(item.id))
              }, _hoisted_66, 8, _hoisted_64),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger mx-2 w-100",
                style: { marginLeft: '12px' },
                onClick: ($event: any) => (_ctx.deleteMaterialStockItem(item))
              }, _hoisted_69, 8, _hoisted_67)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}